import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  FormControlLabel,
  Switch,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import HoursInput from '../HoursInput';

const PointageForm = ({ 
  formData, 
  onFormChange, 
  releveCodes,
  activities
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleFieldChange = (field, value) => {
    onFormChange({
      ...formData,
      [field]: value,
    });
  };

  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormControl fullWidth size="small">
          <InputLabel>Code Relève</InputLabel>
          <Select
            value={formData.releveCodeId}
            label="Code Relève"
            onChange={(e) => handleFieldChange('releveCodeId', e.target.value)}
          >
            {releveCodes.map((code) => (
              <MenuItem key={code.id} value={code.id}>
                {code.code}{code.role ? ` (${code.role})` : ''}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <InputLabel>Activité</InputLabel>
          <Select
            value={formData.activityId}
            label="Activité"
            onChange={(e) => handleFieldChange('activityId', e.target.value)}
          >
            {activities.map((activity) => (
              <MenuItem key={activity.id} value={activity.id}>
                {activity.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          size="small"
          label="Description"
          value={formData.description}
          onChange={(e) => handleFieldChange('description', e.target.value)}
          fullWidth
          multiline
          rows={2}
        />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <HoursInput
            value={formData.hours || 0}
            onChange={(newValue) => handleFieldChange('hours', newValue)}
            size="small"
            sx={{ flex: 1, mr: 1 }}
          />

          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={formData.on_report}
                onChange={(e) => handleFieldChange('on_report', e.target.checked)}
              />
            }
            label="Fait Marquant"
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flex: 1, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ width: 150 }}>
        <InputLabel>Code Relève</InputLabel>
        <Select
          value={formData.releveCodeId}
          label="Code Relève"
          onChange={(e) => handleFieldChange('releveCodeId', e.target.value)}
        >
          {releveCodes.map((code) => (
            <MenuItem key={code.id} value={code.id}>
              {code.code}{code.role ? ` (${code.role})` : ''}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ width: 180 }}>
        <InputLabel>Activité</InputLabel>
        <Select
          value={formData.activityId}
          label="Activité"
          onChange={(e) => handleFieldChange('activityId', e.target.value)}
        >
          {activities.map((activity) => (
            <MenuItem key={activity.id} value={activity.id}>
              {activity.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Description"
        value={formData.description}
        onChange={(e) => handleFieldChange('description', e.target.value)}
        sx={{ flex: 1 }}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 270 }}>
        <HoursInput
          value={formData.hours || 0}
          onChange={(newValue) => handleFieldChange('hours', newValue)}
          size="small"
          fullWidth
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={formData.on_report}
              onChange={(e) => handleFieldChange('on_report', e.target.checked)}
            />
          }
          label="Fait Marquant"
        />
      </Box>
    </Box>
  );
};

export default PointageForm;
